// extracted by mini-css-extract-plugin
module.exports = {"container":"Ks6aDocumentInfo_container__2H-td","item":"Ks6aDocumentInfo_item__pKSp1","underlined":"Ks6aDocumentInfo_underlined__1FR7z"};